// extracted by mini-css-extract-plugin
module.exports = {"downloadIcon":"DataAbout_downloadIcon__2RQi-","fieldName":"DataAbout_fieldName__1YsYE"};